import { render, staticRenderFns } from "./platWarn.vue?vue&type=template&id=0f13fb86&scoped=true"
import script from "./platWarn.vue?vue&type=script&lang=js"
export * from "./platWarn.vue?vue&type=script&lang=js"
import style0 from "./platWarn.vue?vue&type=style&index=0&id=0f13fb86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f13fb86",
  null
  
)

export default component.exports